import { FC, useContext, useEffect } from "react"

import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import { downloadExcelFile } from "src/helpers/downloadFile";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";
import { MANUFACTURER_REPORT_NAMES } from "src/constants/manufacturer";



const StatsReports: FC<StatsReportProps> = ({ getValues }): JSX.Element => {
  // const [_, setEnabledButton] = useState<boolean>(false);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);




  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if(downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
        showToast(["Report downloaded successfully"], ToastTypes.SUCCESS)
        hideLoader();
      } else {
        hideLoader()
      }

      // setEnabledButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = (e: React.MouseEvent,reportName: string) => {
    e.stopPropagation(); 
    e.preventDefault();
   if(getValues){
    let params = {
      'start_date':getValues().start_date,
      'end_date' : getValues().end_date,
      'report_name': reportName
    }
    if (downloadReportsData || downloadReportsError) clearRequestFileData();
    setLoader();
    // setEnabledButton(true)
    downloadRequestForm({}, {}, params);
   }
  }



  return (
    <div className="row justify-content-between align-items-center gx-2 download-reports">
        <>
          {MANUFACTURER_REPORT_NAMES.map((report, index) => (
            <div className="col" key={index}>
              <button
                className="btn btn-purple rounded-0 w-100 m-0 mt-2"
               // onClick={() => downloadReport(report)}
               onClick={(e) => downloadReport(e, report)}
                key={index+1}
              >
                {report.replace("Pre", "").trim()}
              </button>
            </div>
          ))}
        </>
    </div>
  );
};

export default StatsReports;
